export default {
  WenMei: {
    bannerList: [
      {
        titleKey: 'details.WenMei.banner.title',
        descKey: 'details.WenMei.banner.desc',
        btnText: '',
        image: require('@/assets/img/Details/details-01.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    alternateList: [
      { titleKey: 'details.WenMei.list.item1.title', descKey: 'details.WenMei.list.item1.desc' },
      { titleKey: 'details.WenMei.list.item2.title', descKey: 'details.WenMei.list.item2.desc' },
      { titleKey: 'details.WenMei.list.item3.title', descKey: 'details.WenMei.list.item3.desc' }
    ],
    caseList: [
      {
        titleKey: 'home.cases.safetyAssistant.title',
        descKey: 'home.cases.safetyAssistant.desc',
        effectKey: '',
        evaluationKey: '',
        image: require("@/assets/img/Products/case/产品中心-问煤-case.png")
      }
    ]
  },
  YiMei: {
    bannerList: [
      {
        titleKey: 'details.YiMei.banner.title',
        descKey: 'details.YiMei.banner.desc',
        btnText: ' ',
        image: require('@/assets/img/Details/details-01.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    alternateList: [],
    caseList: []
  }
}